import { useQuery, gql, useLazyQuery } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"
import * as Sentry from "@sentry/browser"
import { ASSET_TYPE_FIELDS } from "./fragments/assetTypeFieldsFragment"

const ASSET_TYPES_LIMIT = 20

const ASSET_TYPES_QUERY = gql`
  query AssetTypes($filter: AssetTypesFilterInput, $offset: Int, $limit: Int) {
    assetTypes {
      list(filter: $filter, limit: $limit, offset: $offset) {
        ...AssetTypeFields
      }
      count
    }
  }
  ${ASSET_TYPE_FIELDS}
`

const useQueryAssetTypes = (options) => useQuery(ASSET_TYPES_QUERY, options)

const loadMore = (result) => async () => {
  try {
    const currentCount = result.data?.assetTypes?.list?.length || 0
    if (currentCount % ASSET_TYPES_LIMIT !== 0) {
      return // 🚫 not a full page, stop
    }

    await result.fetchMore({
      variables: {
        ...result.variables,
        offset: result.data.assetTypes.list.length,
        limit: ASSET_TYPES_LIMIT
      }
    })
  } catch (error) {
    console.log(error)
    Sentry.captureException(error)
  }
}

const useLazyQueryAssetTypes = (options) => {
  const { variables, ...otherOptions } = options || {}
  const [loadItems, result] = useLazyQuery(ASSET_TYPES_QUERY, {
    variables: {
      offset: 0,
      limit: ASSET_TYPES_LIMIT,
      ...variables
    },
    fetchPolicy: "cache-and-network",
    ...otherOptions
  })

  return [
    loadItems,
    {
      ...result,
      loadMore: loadMore(result)
    }
  ]
}

const assetTypesTypePolicies = {
  scoped: {
    AssetTypesQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      },
      fields: {
        list: offsetLimitPagination(["filter"])
      }
    }
  }
}

export { useQueryAssetTypes, useLazyQueryAssetTypes, assetTypesTypePolicies, ASSET_TYPES_QUERY }
